import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const emailPlannedToShipperRenderer = ({ changes: { planned_time }, ...props }) => {
  return (
    <Spacer {...props}>
      {!!planned_time && (
        <Text color="grey800" display="block">
          Shipper will be notified by email at {planned_time} if the driver is still late
        </Text>
      )}
    </Spacer>
  );
};

export default emailPlannedToShipperRenderer;
